export default (theme: any) => ({
    small: {
        width: theme.spacing(2.5),
        height: theme.spacing(2.5),
    },
})
